"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActivityDescription;

var _predicates = require("../../typescript/predicates");

var _activityDescriptionConfig = require("./activityDescriptionConfig");

function getActivityDescription(_ref) {
  var t = _ref.t,
      locale = _ref.locale,
      measurementSystem = _ref.measurementSystem,
      _ref$configs = _ref.configs,
      configs = _ref$configs === void 0 ? _activityDescriptionConfig.activityDescriptionConfigs : _ref$configs,
      _ref$defaultConfig = _ref.defaultConfig,
      defaultConfig = _ref$defaultConfig === void 0 ? _activityDescriptionConfig.defaultDescriptionConfig : _ref$defaultConfig,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? ' - ' : _ref$separator,
      durationFormat = _ref.durationFormat,
      trim = _ref.trim,
      usePlural = _ref.usePlural;
  return function (_ref2) {
    var activity = _ref2.activity;
    return (configs.get(activity.type) || defaultConfig).map(function (displayer) {
      var _displayer;

      return (_displayer = displayer({
        activity: activity,
        t: t,
        locale: locale,
        measurementSystem: measurementSystem,
        durationFormat: durationFormat,
        trim: trim,
        usePlural: usePlural
      })) === null || _displayer === void 0 ? void 0 : _displayer.value;
    }).filter(_predicates.notUndefined).join(separator);
  };
}
//# sourceMappingURL=getActivityDescription.js.map